import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../data/content";

export const FloatingWhatsApp = () => (
  <motion.a
    data-testid="floating-whatsapp-btn"
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 right-6 z-[60] flex items-center gap-3"
    aria-label="Konsultasi gratis via WhatsApp"
  >
    <span className="hidden sm:block opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 bg-surface border border-white/10 text-bone text-xs font-light px-4 py-2.5">
      Konsultasi Gratis via WA
    </span>
    <span className="wa-pulse flex items-center justify-center w-14 h-14 rounded-full bg-wa group-hover:bg-wahover transition-colors duration-300">
      <MessageCircle className="w-6 h-6 text-obsidian" strokeWidth={2} fill="currentColor" />
    </span>
  </motion.a>
);
